import React from "react";
import "../styles/BackToTop.css";

function BackToTop() {
  const scrollTop = (e) => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="flex items-center  justify-center w-full">
      <div className="back-to-top header-style-cta" onClick={scrollTop}>
        Back To Top
      </div>
    </div>
  );
}

export default BackToTop;
